import type UserProfileBasedSecurity from "@/interfaces/Security/UserProfileBasedSecurity";
import { portalHttpClient } from "@/services/httpClient";

const END_POINT = "api/customerPortal/v1/userProfileBasedSecurity";

export async function getUserProfileBasedSecurity(): Promise<UserProfileBasedSecurity> {
  const response = await portalHttpClient.get(END_POINT);
  return response.data as UserProfileBasedSecurity;
}
